<template>
  <v-card style="border-width: 0">
    <v-card-title>
      {{ $t('group.assign_module', {name: $i18n.locale === 'jp' ? userGroup.name_jp : userGroup.name_en , id: userGroup.id}) }}
    </v-card-title>
    <v-card-text>
      <v-autocomplete
        v-model="selectedModuleIds"
        :items="items"
        item-value="id"
        :item-text="$i18n.locale === 'jp' ? 'name_jp' : 'name_en'"
        :loading="loading"
        :disabled="loading"
        outlined
        color="primary"
        multiple
        dense
        chips
        deletable-chips
        hide-details
      />
    </v-card-text>
    <v-card-actions class="px-6 pb-4">
      <v-btn
        outlined
        color="primary"
        :disabled="loading"
        :loading="loading"
        @click="onAssignModule"
      >
        {{ $t('common.save') }}
      </v-btn>
      <v-btn
        outlined
        color="complimentary"
        :disabled="loading"
        @click="onCancelAssignModule"
      >
        {{ $t('common.cancel') }}
      </v-btn>
    </v-card-actions>
    <v-alert
      v-model="errorState"
      dense
      type="error"
      dismissible
      class="mb-0 custom-alert-border"
    >
      {{ error }}
    </v-alert>
  </v-card>
</template>

<script>

import QUATSError from '../plugins/error'

export default {
  props: {
    userGroup: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      error: null,
      loading: true,
      selectedModuleIds: this.userGroup.page_groups.filter(x => !x.hidden && !x.auto_allowed).map(x => x.id),
      items: [],
      errorState: false
    }
  },

  mounted() {
    const promises = [
      window.axios.get('/api/page-groups')
    ]
    Promise.all(promises)
      .then(result => {
        this.items = (result[0].data.data || []).filter(x => !x.hidden && !x.auto_allowed)
      })
      .catch( err => {
        this.error = new QUATSError(this.$i18n, err).message
        this.errorState = true
      })
      .finally(() => this.loading = false)
  },

  methods: {
    onAssignModule () {
      this.loading = true
      const data = {
        user_group_id: this.userGroup.id,
        page_group_ids: this.selectedModuleIds
      }
      const promises = [
        window.axios.patch('/api/group/user-groups/page-groups/sync', data)
      ]
      Promise.all(promises)
        .then( result => this.$emit('assignCompleted', result[0].data.data))
        .catch( err => {
          this.error = new QUATSError(this.$i18n, err).message
          this.errorState = true
        })
        .finally(() => this.loading = false)
    },

    onCancelAssignModule() {
      this.$emit('assignCancel')
    }
  }
}
</script>

<style scoped>
.custom-alert-border {
  font-size: 80%;
  border-top-right-radius: 0;
  border-top-left-radius: 0;
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
</style>
